/**
 * Platform detection utilities for iOS app vs web.
 *
 * The iOS native app sets window.__IS_IOS_APP__ = true and
 * window.__IS_RN_WEBVIEW__ = true via injected JavaScript.
 */

/** Returns true when running inside the iOS native app WebView. */
export const isIOSApp = (): boolean =>
  typeof window !== 'undefined' && !!(window as any).__IS_IOS_APP__;

/** Returns true when running inside any React Native WebView (iOS or Android). */
export const isRNWebView = (): boolean =>
  typeof window !== 'undefined' && !!(window as any).__IS_RN_WEBVIEW__;

/** Returns true when running inside the Android native app WebView. */
export const isAndroidApp = (): boolean =>
  isRNWebView() && !isIOSApp();
